exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inset[data-v-0e6fac04]{float:left;margin-right:1em;margin-bottom:1em;max-width:33%}.inset.right[data-v-0e6fac04]{float:right;margin-right:0;margin-left:1em}.inset[data-v-0e6fac04]:after{clear:both}.content[data-v-0e6fac04] p:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e6fac04","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Content/Generic.vue
// module id = 285
// module chunks = 7 8 9